import VueElementLoading from 'vue-element-loading';
import CryptoJS from "crypto-js";
import moment from 'moment';
import CONSTANT from './../../../../shared/constants/constant';
import Printd from 'printd'
import VueBarcode from 'vue-barcode';
import pdfMake from "pdfmake/build/pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Util from './../../../../shared/util/util';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import AdminSettingsService from './../../../../adminsettings/services/adminsettings.service'

export default {
  name: 'lr-copy',
  components: {
    VueElementLoading,
    'barcode': VueBarcode
  },
  props: ['selectedData','copytype'],
  data: function() {
    return {
      PrintAWBModal: false,
      bookingData: JSON.parse(JSON.stringify(this.selectedData)),
      bookingmode: '',
      NonDOX :'',
      DOX :'',
      awbNo:'',
      noofmps:'',
      phywt:'',
      volwt:'',
      chargedwt: '',
      copy:[{value:"SHIPPER COPY"},{value:"ACCOUNT COPY"},{value:"CONSIGNEE COPY"},{value:"POD COPY"}],
      isRelianceSecondaryClient:false,
      consigneecodelable: 'Customer Code',
      consigneereceiverlable: 'Receiver',
      ponumberlable: 'PO NO.',
      shippersenderlabel: 'Sender',
      shippercode:"",
  	  userdata:'',
  	  bookinglabel1:'',
  	  bookinglabel2:'',
  	  bookinglabel3:'',
  	  bookingfield1:'',
  	  bookingfield2:'',
  	  bookingfield3:''
    }
  },
  computed: {},
  mounted () {
  	var userdetailEncrypt = window.localStorage.getItem(
  		"cargoAutoaccessuserdata"
  	);
	  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
	  let date = Util.getCurrentDate()
    var mydate = moment.utc(date).format("DD-MM-YYYY").valueOf();
    userdetail.date = mydate
    this.userdata = userdetail
    this.userName = userdetail.email;
    this.hubid = userdetail.hubID[0];
    this.hubName =  userdetail.currenthubname;
    this.awbNo = this.bookingData.awbnumber;
    if(this.bookingData.field1label){
      this.bookinglabel1 = this.bookingData.field1label
    }
  	if(this.bookingData.field2label){
  		this.bookinglabel2 = this.bookingData.field2label
  	}
  	if(this.bookingData.field3label){
  		this.bookinglabel3 = this.bookingData.field3label
  	}
  	if(this.bookingData.field1value){
  		this.bookingfield1 = this.bookingData.field1value
  	}
  	if(this.bookingData.field2value){
  		this.bookingfield2 = this.bookingData.field2value
  	}
  	if(this.bookingData.field3value){
  		this.bookingfield3 = this.bookingData.field3value
  	}
    if (this.bookingData.bookingmode && (this.bookingData.bookingmode.toLowerCase() == 'to pay' || this.bookingData.bookingmode.toLowerCase() == 'topay')) {
      this.bookingmode = CONSTANT.BOOKING_MODE['To Pay']
    }else {
      this.bookingmode = CONSTANT.BOOKING_MODE[this.bookingData.bookingmode]
    }
    if(this.copytype){
    	this.copy = [{value:"EXTRA COPY"}];
    }
    if((this.bookingData.clienttype && this.bookingData.clienttype =="SalesFranchise") || this.bookingData.clientweightdisabledflag==1){
      this.phywt = '';
      this.volwt = '';
      this.chargedwt = '';
      this.noofmps = '';
    }else{
      this.phywt = this.bookingData.totalphysicalweight;
      this.volwt = this.bookingData.totalvolumetricweight;
      this.chargedwt = (parseFloat(this.phywt)>parseFloat(this.volwt))?this.phywt:this.volwt;
      this.noofmps = this.bookingData.numberofmps;
    }
    if(this.bookingData.reliancesecondaryclient== 1){
      this.consigneecodelable = 'Receiver Site Code';
      this.consigneereceiverlable = 'Receiver POC';
      this.ponumberlable = 'STN No';
      this.shippersenderlabel = 'Sender Site Code';
      this.shippercode = (this.bookingData.pickupname=="SPOC Details")?"":this.bookingData.pickupname;
    }else{
      this.shippercode = this.bookingData.bookingsource == 'ClientAPI' ? (this.bookingData.pickupname=="SPOC Details")?"":this.bookingData.pickupname : this.bookingData.businessaccountname;
    }
	  this.getCustomiseAWBCopyData(this.bookingData.clientid,this.bookingData.clientbusinessacountid)
  },
  methods: {
    closePrintAWBModal(){
       this.PrintAWBModal = false;
    },
    DownloadAWB(){
      const contentHtml = document.getElementById('printAWBData').innerHTML;
      var html = htmlToPdfmake(contentHtml);
      var docDefinition = {
       content: [
         html
       ],
       styles:{
         'with-margin':{
           marginLeft: 30 // apply a margin with the specific class is used
         }
       }
      };
      pdfMake.createPdf(docDefinition).download();
    },
    printAWBPage() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          h3 {
          page-break-after: always;
          }
          }
          `
      d.print(document.getElementById('printAWBData'), cssText);
    },
	async getCustomiseAWBCopyData(clientid,clientbusinessaccountid){
		try {
			this.isLoading = true;
			let inputPayload = {}
			inputPayload.clientId = clientid
			inputPayload.clientBusinessAccountId = clientbusinessaccountid
			let result = await AdminSettingsService.getClientSettings(inputPayload)
			this.isLoading = false;
			if (result.data.code == 200) {
				let clientSettingData  = result.data.data[0].configparam
				this.awblrcopy = false;
				if(clientSettingData.awbcopy){
					this.awblrcopy = result.data.data[0].configparam.awbcopy.ischecked!=0 ? true : false
				}
				if(this.awblrcopy){
				  this.bookinglabel1 = clientSettingData.awbcopy.field1 != null ? clientSettingData.awbcopy.field1.label : "",
				  this.bookingfield1 = clientSettingData.awbcopy.field1 != null ? this.bookingData.awbcopydata[clientSettingData.awbcopy.field1.columnname] : ""
				  this.bookinglabel2 = clientSettingData.awbcopy.field2 != null ? clientSettingData.awbcopy.field2.label : "",
				  this.bookingfield2 = clientSettingData.awbcopy.field2 != null ? this.bookingData.awbcopydata[clientSettingData.awbcopy.field2.columnname] : ""
				  this.bookinglabel3 = clientSettingData.awbcopy.field3 != null ? clientSettingData.awbcopy.field3.label : "",
				  this.bookingfield3 = clientSettingData.awbcopy.field3 != null ? this.bookingData.awbcopydata[clientSettingData.awbcopy.field3.columnname] : ""
				}
			}
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}
	}
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/LRCopy/LRCopy.js